import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { rootCssSet } from "../../utils/helpers/common";

const initialState = {
  templateTypesListReset: false,
  templateTypesFilter: false,
  multipleActionDialog: false,
};

export const designTemplateSlice = createSlice({
  name: "design-template",
  initialState,
  reducers: {
    setTemplateTypesListReset: (state) => {
      state.templateTypesListReset = !state.templateTypesListReset;
    },

    setMultipleActionDialog: (state) => {
      state.multipleActionDialog = !state.multipleActionDialog;
    },

    setTemplateTypesFilter: (state) => {
      state.templateTypesFilter = !state.templateTypesFilter;
      rootCssSet();
    },
  },
});

export const designTemplateAction = designTemplateSlice.actions;
export const designTemplateReducer = designTemplateSlice.reducer;
